module.exports = __webpack_public_path__ + "statics/img/SmartLogistics-3.dfa49480.png";